/**
 * Created by fers on 23/04/2017.
 */

import Relay from 'react-relay';

export function getDataSourceFragment() {
    return Relay.QL`
        fragment on DataSource {
            ${getDataSourceDefinitionFragment()}
            id,
            screen_id,
            channels {
                id,
                realId,
                name,
                channelDef {
                    id,
                    realId,
                    name,
                    icon
                }
            },
        }
    `;
}


export function getDataSourceDefinitionFragment() {
    return Relay.QL`
        fragment on DataSource {
            id,
            idx,
            realId,
            type,
            typeId,
            description,
			relativeTo_id,
			scenarioDef_id,
            relativeTo {
                id,
                realId,
            },
            entityDefs {
                id,
                realId,
                icon,
                inheritedIcon,
                key,
                name,
            },
            primaryEntityDef {
                id,
                realId,
                icon,
                inheritedIcon,
                key,
                name,
                allFieldDefs(first: 20000) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                            shortName,
                            description,
                            type,
                            exampleData
                        }
                    }
                },
                groupDef {
                    id,
                    realId,
                    name
                }
            },
            channelDefKeys,
            channelDefs {
                id,
                realId,
                name,
                icon
            },
            args
        }
    `;
}

export function getViewDefinitionFragment() {
    return Relay.QL`
        fragment on View {
            id,
            realId,
            handler,
            dataSource_id,
			template,
			filter,
			order,
            connectedChannelDef {
                id,
                realId,
                icon
            },
            entityViewDef {
                id,
                realId,
                name,
                description,
                handler,
                forList,
                title,
                template,
				filter,
				order,
                dependsOnChannelDef {
                    id,
                    icon
                },
                entityDef {
                    id,
                    realId,
                    icon,
                    inheritedIcon
                    name,
					key,
                    groupDef {
                        id,
                        name
                    }
                }
            },

        }
    `;
}


export function getViewFragment() {
    return Relay.QL`
        fragment on View {
            id,
            ${getViewDefinitionFragment()}
            channelAddon {
                id,
                realId,
                name,
                channel {
                    id,
                    realId,
                },
                channel_id,
                organisation_id,
                options,
                addonDef {
                    id,
                    name,
                    description,
                    realId,
                    handler,
                    options,
                }
            },
            connectedChannel {
                id,
                realId,
                organisation_id,
                channelDef {
                    id,
                    icon
                }
            },
        }
    `;
}
